import request from '@/utils/request'

const prefix = '/django_rest/company/offer-letter-template-management'
const templateFieldPrefix = '/django_rest/company/offer-letter-field-management'
const inviteRecordPrefix = '/django_rest/offer-letter/invite-record-management'

export default {
  getOfferLetterTemplateList (params) {
    return request.get(`${prefix}/`, { params })
  },
  getOfferLetterTemplateInfoById (templateId) {
    return request.get(`${prefix}/${templateId}/`)
  },
  createOfferLetterTemplate (params) {
    return request.post(`${prefix}/`, params)
  },
  updateOfferLetterTemplate (params) {
    return request.put(`${prefix}/${params.id}/`, params)
  },
  getOfferLetterTemplateFieldList (params) {
    return request.get(`${templateFieldPrefix}/`, { params })
  },
  getOfferLetterTemplateFieldInfoById (fieldId) {
    return request.get(`${templateFieldPrefix}/${fieldId}/`)
  },
  createOfferLetterTemplateField (params) {
    return request.post(`${templateFieldPrefix}/`, params)
  },
  updateOfferLetterTemplateField (params) {
    return request.put(`${templateFieldPrefix}/${params.id}/`, params)
  },
  moveTemplateFieldOrder (params) {
    return request.post(`${templateFieldPrefix}/order/`, params)
  },
  getOfferLetterInviteRecordList (params) {
    return request.get(`${inviteRecordPrefix}/`, { params })
  },
  getOfferLetterInviteRecordInfoById (params) {
    return request.get(`${inviteRecordPrefix}/${params.invite_id}/`, { params })
  },
  saveCandidateOfferLetterOperate (params) {
    return request.post('/django_rest/candidate/operate/offer-letter/', params)
  },
  createExportOfferInviteRecordTask (params) {
    return request.post('/django_rest/offer-letter/invite-record/export/', params)
  },
  getExportOfferInviteRecordTaskInfo (params) {
    return request.get('/django_rest/offer-letter/invite-record/export/', { params })
  }
}
